"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagesIdtoURL = exports.jsonTemplateToPassJson = void 0;

var _lodash = require("lodash");

var _types = require("../types");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _convert = function _convert(input, language) {
  if ((0, _lodash.isObject)(input) && (0, _lodash.has)(input, 'type')) {
    var type = (0, _lodash.get)(input, 'type');

    switch (type) {
      case 'object':
        {
          var inputProps = (0, _lodash.get)(input, 'properties');
          var props = {};
          Object.keys(inputProps).forEach(function (p) {
            props[p] = _convert(inputProps[p], language);
          });
          return props;
        }

      case 'array':
        {
          var inputItems = (0, _lodash.get)(input, 'items');
          var items = [];
          inputItems.forEach(function (p) {
            items.push(_convert(p, language));
          });
          return items;
        }

      case 'string':
        {
          var value = (0, _lodash.get)(input, 'value');

          if ((0, _lodash.isString)(value)) {
            return value;
          }

          return value[language];
        }
      // TODO - check placeholders

      default:
        {
          return (0, _lodash.get)(input, 'value');
        }
    }
  }

  return input;
};

var jsonTemplateToPassJson = function jsonTemplateToPassJson(jsonTemplate, language) {
  var props = {};
  Object.keys(jsonTemplate).forEach(function (p) {
    props[p] = _convert((0, _lodash.get)(jsonTemplate, p), language);
  });
  return props;
};

exports.jsonTemplateToPassJson = jsonTemplateToPassJson;

var _imageToUrl = function _imageToUrl(id, imageBaseUrl) {
  var url = "".concat(imageBaseUrl, "/").concat(id.substring(0, 2), "/").concat(id.substring(2), ".png");
  return url;
};

var imagesIdtoURL = function imagesIdtoURL(images) {
  var imageBaseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://yrps.s3.amazonaws.com/img';
  var language = arguments.length > 2 ? arguments[2] : undefined;
  var res = {};

  var _iterator = _createForOfIteratorHelper(_types.imageTypes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var imageType = _step.value;

      if (images[imageType]) {
        if ((0, _lodash.isObject)(images[imageType])) {
          (function () {
            var t = images[imageType];
            var i = {};
            var firstLang = void 0;
            Object.keys(t).sort().forEach(function (lang, index) {
              if (index === 0) {
                firstLang = lang;
              }

              var v = t[lang];

              if (v) {
                i[lang] = _imageToUrl(v, imageBaseUrl);
              }
            });
            res[imageType] = i[language] || i['en'] || (firstLang ? i[firstLang] : undefined);
          })();
        }

        if ((0, _lodash.isString)(images[imageType])) {
          res[imageType] = _imageToUrl(images[imageType], imageBaseUrl);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
};

exports.imagesIdtoURL = imagesIdtoURL;
//# sourceMappingURL=jsonTemplate.js.map